export interface INotificacaoSistemaAviso {
  id: number;
  nome?: string;
  descricao: string;
  is_habilitar_nao_mostrar_novamente?: boolean | number | string;
}

export interface INotificacaoSistemaResponse {
  status_code?: number;
  avisos: INotificacaoSistemaAviso[];
}

export interface IOcultarAvisoNotificacaoPayload {
  notificacao_sistema_id: number;
}

export function isOpcaoNaoMostrarNovamenteHabilitada(aviso: INotificacaoSistemaAviso): boolean {
  const valorOpcaoNaoMostrar = aviso?.is_habilitar_nao_mostrar_novamente;
  return valorOpcaoNaoMostrar === true
    || valorOpcaoNaoMostrar === 1
    || valorOpcaoNaoMostrar === '1'
    || valorOpcaoNaoMostrar === 'true';
}
